import {injectReducer} from '../../store/reducers'
import { isLoggedIn } from 'utils/auth'

export default (store) => ({
  path: 'segment',
  onEnter: isLoggedIn(store),
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const Home = require('./containers/HomeContainer').default;
      var homeReducers = require('./modules/home');
      const homeReducer = homeReducers.dayReducer;
      const selectHierarchyReducer = homeReducers.selectHierarchyReducer;
      const timeSeriesChartDataReducer = require('components/TimeSeriesChart/reducers').default;
      const widgetDataReducer = require('components/StatsWidget/reducers').default;
      const hierarchiesReducer = require('components/HierarchySelect/reducers').default;
      const timeRangeSelectReducer = require('components/TimeRangeSelect/reducers').default;
      // const sbReducer = require('components/SunburstChart/reducers').default;
      // const heatMapReducer = require('components/HeatMap/reducers').default;
      // const handleFilters = require('components/SunburstChart/reducers').handleFilters;

      /*  Add the reducer to the store on key 'counter'  */
      // injectReducer(store, { key: 'sb', reducer: sbReducer });
      // injectReducer(store, { key: 'filter', reducer: handleFilters });
      // injectReducer(store, { key: 'heatMapData', reducer: heatMapReducer });

      /*  Return getComponent   */
      cb(null, Home)

      /* Webpack named bundle   */
    }, 'segment')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Segment/index.js